/**
 * @module logger
 * @description Pino-based structured logging with pluggable reporters
 */

import type { ModuleManifest, ModuleContext } from '@gzl10/nexus-sdk'
import { getLoggerConfig, initLoggerService, getPinoLogger, setLoggerInstance } from '@kernel/logger/index.js'
import { loggerConfigEntity, healthAction, clientErrorsEntity, reportClientErrorAction } from './logger.entity.js'

// Re-export types desde core
export type { LoggerConfig, LoggerService } from '@kernel/logger/types.js'

export const loggerModule: ModuleManifest = {
  name: 'logger',
  label: { en: 'Logger', es: 'Registro' },
  icon: 'mdi:text-box-outline',
  description: { en: 'Centralized logging with Pino and optional Sentry integration', es: 'Registro centralizado con Pino e integración opcional con Sentry' },
  type: 'core',
  category: 'analytics',
  dependencies: [], // Sin dependencias - debe cargar primero
  definitions: [
    loggerConfigEntity,
    clientErrorsEntity
  ],

  actions: [
    healthAction,
    reportClientErrorAction
  ],
  init: (ctx: ModuleContext) => {
    const config = getLoggerConfig()
    const service = initLoggerService(config)
    // Registrar servicio
    ctx.services.register('logger', service)
    // Actualizar el logger global de shared/logger.ts
    setLoggerInstance(getPinoLogger())
    service.debug('Logger module initialized')
  },
  routePrefix: '/logger'
}
